import {useState} from 'react'
import {useOutletContext} from 'react-router'
import {Button} from 'brand/Button'
import {justValues, vibes} from './answers'

const answers = justValues(vibes)
const maxAnswers = 2

export const Vibes = () => {
  const {submitAnswers} = useOutletContext()
  const [selectedAnswers, setSelectedAnswers] = useState([])

  const isSelected = answer => selectedAnswers.includes(answer)
  const toggleAnswer = answer => {
    let selected = [...selectedAnswers]
    if (selected.includes(answer)) {
      selected = selected.filter(it => it !== answer)
    } else {
      selected.push(answer)
      if (selected.length > maxAnswers) {
        selected = selected.slice(-maxAnswers)
      }
    }
    setSelectedAnswers(selected)
  }
  const submit = (values = selectedAnswers) => submitAnswers(values)

  return (
    <>
      <div className="column">
        <section className="question">
          <div className="content size-xl">I want to look and feel...</div>
        </section>
        <section className="answers">
          <div className="content">
            {answers.map(it => (
              <Button
                size="large"
                selected={isSelected(it)}
                action={() => toggleAnswer(it)}
                key={it}
              >
                {it}
              </Button>
            ))}
          </div>
        </section>
      </div>
      <section className="float-bottom">
        <div className="content">
          <Button size="large" action={() => submit()}>Next</Button>
        </div>
      </section>
    </>
  )
}
